import React, { useEffect, useState } from 'react'
import "../../Assets/Css/Tickets.scss"
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { useLocation, useNavigate } from 'react-router-dom';
import Select from "react-select";
import { customStyle } from '../../Components/Style';
import { connect } from 'react-redux';
import { getDepartments } from '../../Services/Department/action';
import { addNotice, updateNotice } from '../../Services/Notice/action';
import DatePicker from 'react-datepicker';
import { toast } from 'react-toastify';


const NoticeBoardAddEdit = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const data = location?.state?.data?.allData;
    useEffect(() => {
        props?.getDepartments();
    }, [])

    const Department = props?.department?.map(item => {
        return {
            value: item?.id,
            label: item?.name
        }
    });
    const [Fields, setFields] = useState({
        start_date: data?.start_date || null,
        no_of_days: data?.no_of_days || '',
        employee: data?.to?.toLowerCase() || '',
        details: data?.details || "",
        heading: data?.heading || "",
        Department: "",
    });

    useEffect(() => {
        if (props?.department?.length > 0 && data?.department_id) {
            const DepartmentOptions = props?.department?.map(item => ({
                value: item.id,
                label: item.name,
            }));
            const matchedDept = DepartmentOptions?.find(item => item?.value === data?.department_id);
            if (matchedDept) {
                setFields(prev => ({
                    ...prev,
                    Department: matchedDept,
                }));
            }
        }
    }, [props?.department, data?.department_id]);


    const handleSave = async () => {
        try {
            if (!Fields?.start_date || !Fields?.no_of_days || !Fields?.heading) {
                toast.error("Please fill all the required fields");
                return;
            }
            const body = {
                start_date: Fields?.start_date,
                no_of_days: Fields?.no_of_days,
                heading: Fields?.heading,
                details: Fields?.details,
                department_id: Department?.find(item => item?.label == Fields?.Department?.label)?.value,
            }
            if (data) {
                await props?.updateNotice(data?.id, body);
            }
            else {
                await props?.addNotice(body);
            }
            navigate(-1)
        } catch (error) {
            console.error("Error while saving notice :", error);
        }
    }

    return (
        <div className='ticket-container mb-5'>
            <div className="page-title">
                <h4>{location.pathname === "/notice/add" ? "Add" : "Update"} Notice</h4>
                <div className="edit-btn">
                    <button
                        type="submit"
                        className="custom-btn"
                        onClick={() => navigate(-1)}
                    >Cancel</button>

                    <button
                        type="submit"
                        className="custom-btn"
                        onClick={handleSave}
                    >
                        {/* {props.loading ? (
                                        <Spinner
                                             as="span"
                                             animation="border"
                                             className="custom-spinner"
                                             role="status"
                                             aria-hidden="true"
                                        />
                                        ) : ( */}
                        Save
                        {/* )} */}
                    </button>
                </div>
            </div>

            <div className='row parent-filter m-0 pt-4 pb-5 h-auto mb-4'>
                <div className="col-lg-6 col-md-6 description ">
                    <div className='input-group'>
                        <label className='label w-100'>Notice Heading <span style={{ color: 'red' }}>*</span></label>
                        <input
                            value={Fields.heading}
                            placeholder='e.g. new ear celebrations at office.'
                            onChange={(e) =>
                                setFields({
                                    ...Fields,
                                    heading: e.target.value,
                                }
                                )
                            }
                        />
                    </div>
                </div>

                <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className='input-group'>
                        <label className='label'>Department </label>
                        <Select
                            value={Fields.Department}
                            onChange={(data) =>
                                setFields({
                                    ...Fields,
                                    Department: data,
                                }
                                )
                            }
                            options={Department}
                            placeholder={"--"}
                            styles={customStyle}
                            theme={(theme) => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    primary25: "#5757fe",
                                    primary: "#5757fe",
                                },
                            })}
                        />
                    </div>
                </div>

                <div className="col-lg-6 col-md-6">
                    <div className="input-group">
                        <h6 className="label">Start Date <span style={{ color: 'red' }}>*</span></h6>
                        <DatePicker
                            styles={customStyle}
                            selected={Fields.start_date ? new Date(Fields.start_date) : null}
                            placeholderText="Select Date"
                            onChange={(date) => {
                                const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
                                    .toISOString()
                                    .split('T')[0];

                                setFields({
                                    ...Fields,
                                    start_date: localDate,
                                });
                            }}
                            dateFormat="dd-MM-yyyy"
                            name="transaction_date"
                            disabled={props.loading}
                            theme={(theme) => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    primary25: '#5757fe',
                                    primary: '#5757fe',
                                },
                            })}
                        />
                    </div>
                </div>

                <div className="col-lg-6 col-md-6 description ">
                    <div className='input-group'>
                        <label className='label w-100'>Number of Days to Display Notice <span style={{ color: 'red' }}>*</span></label>
                        <input
                            type="number"
                            value={Fields.no_of_days}
                            placeholder='Enter No. of days'
                            onChange={(e) =>
                                setFields({
                                    ...Fields,
                                    no_of_days: e.target.value,
                                }
                                )
                            }
                        />
                    </div>
                </div>

                <div className="col-lg-12 z-0 mb-3">
                    <div className="note-part">
                        <lable className='label'>Notice Details</lable>
                        <div className="editor-custom">
                            <CKEditor
                                editor={ClassicEditor}
                                data={Fields?.details || ""}
                                onReady={editor => {
                                    console.log('Editor is ready to use!', editor);
                                }}
                                onChange={(event, editor) => {
                                    const data = editor.getData();
                                    setFields({
                                        ...Fields,
                                        details: data,
                                    })
                                }}
                                onBlur={(event, editor) => {
                                    console.log('Blur.', editor);
                                }}
                                onFocus={(event, editor) => {
                                    console.log('Focus.', editor);
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        loading: state.departmentReducer.loading,
        department: state.departmentReducer.department,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        getDepartments: () => {
            dispatch(getDepartments())
        },
        addNotice: (data) => {
            dispatch(addNotice(data))
        },
        updateNotice: (id, data) => {
            dispatch(updateNotice(id, data))
        }
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(NoticeBoardAddEdit)
